import { render, staticRenderFns } from "./Clotures.vue?vue&type=template&id=5ac97cc5"
import script from "./Clotures.vue?vue&type=script&lang=js"
export * from "./Clotures.vue?vue&type=script&lang=js"
import style0 from "./Clotures.vue?vue&type=style&index=0&id=5ac97cc5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports